import React, { Component } from "react";
import "../../sass/blocks/_success.scss";
import parse from "html-react-parser";

export class Success extends Component {
    continue = (e) => {
        e.preventDefault();
        // PROCESS FORM //
        this.props.nextStep();
    };

    back = (e) => {
        e.preventDefault();
        this.props.prevStep();
    };

    endContent = JSON.parse(this.props.endPageContent);

    render() {
        return (
            <section
                className="success"
                style={{ background: this.props.background }}
            >
                <h2
                    className="success__heading"
                    style={{ color: this.props.color }}
                >
                    {this.endContent.title}
                </h2>
                {this.endContent.subtitle !== undefined &&
                    this.endContent.subtitle !== null &&
                    this.endContent.subtitle.length > 0 && (
                        <h2 className="success__subtitle">
                            {this.endContent.subtitle}
                        </h2>
                    )}

                {this.endContent.subtitle !== undefined &&
                    this.endContent.subtitle !== null &&
                    this.endContent.subtitle.length > 0 && (
                        <h2 className="success__description">
                            {parse(this.endContent.description)}
                        </h2>
                    )}
            </section>
        );
    }
}

export default Success;
